import { render, staticRenderFns } from "./MasterBase.vue?vue&type=template&id=4af06354&"
import script from "./MasterBase.vue?vue&type=script&lang=ts&"
export * from "./MasterBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports